const translations = {
	optional: "facultatif",
	apportCompteCourant: "Précisez l'origine de l'apport en compte courant",
	paymentByTier: "Le paiement est effectué par un tiers",
	paymentByTierMotive: "Précisez le motif",
	paymentFromFrenchAccount: "Le paiement provient d'un compte français",
	paymentFromCountry: "Précisez le pays",
	civility: "Civilité",
	last_name: "Nom",
	first_name: "Prénom(s)",
	maiden_name: "Nom de jeune fille",
	email: "E-mail",
	office_name: "Mon cabinet",
	mobile_phone: "Téléphone portable (préciser l’indicatif si hors France)",
	spouse: {
		first_name: "Prénom du conjoint",
		last_name: "Nom du conjoint",
		email: "E-mail du conjoint",
		mobile_phone: "Téléphone portable du conjoint (préciser l’indicatif si hors France)",
		birth_date: "Date de naissance du conjoint",
		birth_place: "Lieu de naissance du conjoint",
	},
	address: "Adresse",
	address_automatique: "Adresse (recherche automatique)",
	address_automatique_tooltip: "Pour les TOM, nous vous invitons à indiquer l'adresse manuellement et ne pas utiliser la recherche automatique ",
	postal_code: "Code postal",
	city: "Ville",
	country: "Pays",
	nationality: "Nationalité",
	marital_status: "Situation familiale",
	matrimonial_regime: "Régime matrimonial",
	pacs_regime: "Régime PACS",
	birth_date: "Date de naissance",
	birth_place: "Lieu de naissance",
	birth_department: "Département de naissance (numéro du département)",
	birth_country: "Pays de naissance",
	profession: "Profession (si retraité ancienne profession)",
	line_of_businness: "Secteur d'activité",
	category_social_profession: "Catégorie socio-professionnelle",
	fiscal_regime: "Régime fiscal",
	nif: "Numéro d'Identification Fiscale (NIF) (en cas d'absence, précisez le motif)",
	pourcentage_detention_parts: "% de détention de parts",
	tax_residence_country: "Pays de résidence fiscale",
	legal_capacity: "Capacité juridique",
	politically_exposed_person: "Personne politiquement exposée",
	us_person: "US Person",
	agreement_electronic_document:
		"Accord pour envoi des documents dématérialisés par voie électronique (bordereau fiscal / distribution de revenus / convocations aux AG / publication règlementaire…)*",
	non_professional_classification_acknowledgment:
		"Le ou les souscripteur(s) est(sont) informé(s) que la société de gestion classe les souscripteurs dans la catégorie « client non professionnel » leur permettant ainsi de bénéficier du régime de protection le plus favorable.",
	message: {
		info: {
			recommandation_rib: "Co-souscription recommandée avec RIB compte joint SAUF si réemploi de fonds propres (attestation à fournir)",
		},
		warning: {
			next_step: {
				text: "Afin de passer à l'étape suivante",
				mailTo: "Contactez Wenimmo",
			},
			age_restriction_old: "Votre client a plus de 80 ans : il est possible qu'un document complémentaire vous soit demandé",
			age_restriction_minor: "Votre client est mineur : il est possible qu'un document complémentaire vous soit demandé",
			tax_residence_country_france: "Si différent de France : Merci de prendre contact avec Wenimmo",
			non_professional_classification_acknowledgment: "Nous vous invitons à contacter Wenimmo afin de classer votre client en « client professionnel »",
		},
	},
	payment_methods: {
		description: "Méthode de paiement choisie : ",
		titulary_name: "Nom du titulaire (Nom Prénom comme indiqué sur le RIB)",
		bank_domiciliation: "Domiciliation bancaire",
		iban: "IBAN",
		bic: "BIC",
		organism_name: "Nom de l'organisme",
		download_rib: "Télécharger le RIB",
		nantie_parts: "Les parts seront-elles nanties ?",
		loan_amount: "Montant du prêt",
	},
	funds_origin: "Origine des fonds",
	funds_origin_other: "Veuillez préciser",
	funds_origin_savings: "Précisez l'origine de l'épargne",
	financial_objective: "Objectif d'investissement",
	signature_place: "Lieu de signature (ville en France ou TOM uniquement)",
	community_investment: {
		question: "Merci de préciser si les souscriptions sont effectuées avec : ",
		co_subscription_recommendation: "(co-souscription recommandée)",
	},
	community_funds_origin: "Origine des fonds propres",
	community_funds_origin_other: "Si autre, précisez",
	corporation: {
		raison_social: "Raison sociale",
		siret: "Siret",
		forme_juridique: "Forme juridique",
		addresse: "Addresse du siège social",
		residence_fiscale: "Résidence fiscale",
		residence_fiscale_other: "Précisez",
		regime_fiscal: "Régime fiscal",
		assujetti_ifi: "Assujetti à l'IFI",
		qualite_representant_legal: "Qualité du représentant légal",
	},
};

export default translations;
